const style = document.createElement("style");
style.innerHTML = `
  .ranking-info-container {
    display: flex;
    transition: transform 300ms ease-in-out;
  }
  .carousel-button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 14px;
  }
  .laptop-table-container {
    display: none;
  }
  @media (min-width: 768px) {
    .ranking-info-container {
      display: none;
    }
    .mobile-table-container {
      display: none;
    }
    .laptop-table-container {
      display: block;
    }
  }
`;
document.head.appendChild(style);

// url參數
let scriptId = document.getElementById("fundGroupRankingScript");

let mfxId =
  scriptId && scriptId.attributes["mfx-id"]
    ? scriptId && scriptId.attributes["mfx-id"].value
    : "ALGW";

// 數字格式化
function NumFormatter(num, decimal) {
  this.value =
    num !== null && num !== undefined
      ? num.toLocaleString(undefined, {
          minimumFractionDigits: decimal,
          maximumFractionDigits: decimal,
        })
      : "--";

  this.addPercent = function () {
    this.value =
      num !== null && num !== undefined ? `${this.value}%` : this.value;
    return this;
  };

  this.addPrefix = function () {
    if (num > 0) this.value = `+${this.value}`;
    if (num < 0) this.value = `${this.value}`;
    return this;
  };
}

function numHandler(num, decimal = 2) {
  return new NumFormatter(num, decimal);
}

function formatComma(num, decimal) {
  return numHandler(num, decimal).value; //122,000
}

function formatPercent(num, decimal) {
  return numHandler(num, decimal).addPercent().value; // 12.55%
}

function formatReturnPercent(num, decimal) {
  return numHandler(num, decimal).addPercent().addPrefix().value; //+12.55%
}

function numTextColor(num) {
  if (num !== null && num !== undefined) {
    return num > 0
      ? "text-red-500"
      : num < 0
      ? "text-green-500"
      : "text-gray-500";
  } else {
    return "text-gray-800";
  }
}

function renderRankingHead() {
  // 取得桌機表格的 thead
  const thead = document.getElementById("laptop-ranking-thead");
  const headers = ["項目", "3月", "6月", "1年", "2年", "3年", "5年"];
  const headerHTML = headers
    .map(
      (header, index) => `
      <th style="
        font-weight: 500;
        font-size: 14px;
        text-align: ${index === 0 ? "left" : "right"};
        padding: 8px 16px;
        color: #333333;">
        ${header}
      </th>
    `
    )
    .join("");

  // 取得手機表格的 thead
  const thead1 = document.getElementById("ranking-thead-1");
  const thead2 = document.getElementById("ranking-thead-2");
  const headers1 = ["項目", "3月", "6月", "1年"];
  const headerHTML1 = headers1
    .map(
      (header, index) => `
      <th style="
        font-weight: 500;
        font-size: 14px;
        text-align: ${index === 0 ? "left" : "right"};
        padding: 8px 16px;
        color: #333333;">
        ${header}
      </th>
    `
    )
    .join("");

  const headers2 = ["項目", "2年", "3年", "5年"];
  const headerHTML2 = headers2
    .map(
      (header, index) => `
      <th style="
        font-weight: 500;
        font-size: 14px;
        text-align: ${index === 0 ? "left" : "right"};
        padding: 8px 16px;
        color: #333333;">
        ${header}
      </th>
    `
    )
    .join("");

  //  將內容插入對應的 thead
  thead.innerHTML = `<tr>${headerHTML}</tr>`;
  thead1.innerHTML = `<tr>${headerHTML1}</tr>`;
  thead2.innerHTML = `<tr>${headerHTML2}</tr>`;
}

function renderRankingRow(data) {
  const tbodyDesktop = document.getElementById("laptop-ranking-tbody");
  const tbodyMobile1 = document.getElementById("ranking-tbody-1");
  const tbodyMobile2 = document.getElementById("ranking-tbody-2");

  // 清空表格內容
  tbodyDesktop.innerHTML = "";
  tbodyMobile1.innerHTML = "";
  tbodyMobile2.innerHTML = "";

  const rows = [
    { key: "returnRatio", label: "基金績效" },
    { key: "groupAverageReturnRatio", label: "同類平均" },
    { key: "rankingInfo", label: "同類排名" },
    { key: "peerLeadingRatio", label: "排名領先％" },
  ];

  const periods1 = [
    { key: "threeMonths", label: "3月" },
    { key: "sixMonths", label: "6月" },
    { key: "oneYear", label: "1年" },
  ];

  const periods2 = [
    { key: "twoYears", label: "2年" },
    { key: "threeYears", label: "3年" },
    { key: "fiveYears", label: "5年" },
  ];

  rows.forEach((row, rowIndex) => {
    // 使用輔助函數創建 HTML 並插入到對應的表格
    generatePeriodColumns(
      row,
      periods1.concat(periods2),
      data,
      rowIndex,
      tbodyDesktop
    );
    generatePeriodColumns(row, periods1, data, rowIndex, tbodyMobile1);
    generatePeriodColumns(row, periods2, data, rowIndex, tbodyMobile2);
  });
}

function generatePeriodColumns(row, periods, data, rowIndex, tbody) {
  const rowHTML = periods
    .map((period) => {
      const rawValue = data[row.key][period.key];
      const formattedValue =
        row.key === "rankingInfo"
          ? `${formatComma(rawValue, 0)}/${formatComma(
              data.numberOfSamples[period.key],
              0
            )}`
          : row.key === "peerLeadingRatio"
          ? formatPercent(rawValue)
          : formatReturnPercent(rawValue);

      return `
        <td style="text-align: right; padding: 8px 16px 8px 8px; font-size: 16px;" 
            class="${
              rowIndex === 0 || rowIndex === 1
                ? numTextColor(rawValue)
                : "text-new-gray-800"
            }">
          ${
            formattedValue !== null && formattedValue !== undefined
              ? formattedValue
              : "--"
          }
        </td>`;
    })
    .join(""); // 用 join 來合併所有的 <td> 元素

  const tr = document.createElement("tr");
  tr.style.background = rowIndex % 2 === 1 ? "#F5F5F5" : "";

  const rowHTMLWithTitle =
    `
    <td style="padding-left: 16px; padding-top: 8px; padding-bottom: 8px; text-align: left; color: #666666; font-size: 16px;">
      ${row.label}
    </td>` + rowHTML;

  tr.innerHTML = rowHTMLWithTitle;

  tbody.appendChild(tr); // 插入行到表格
}

// 處理滑動功能
let carouselIndex = 0;
function updateRankingSliderPosition() {
  const slider = document.getElementById("ranking-slider"); // 獲取 slider
  const items = slider ? slider.children : 0; // 取得子項目數量
  // 根據 carouselIndex 的位置來改變背景顏色
  const rankingPrevButton = document.getElementById("rankingPrevButton");
  const rankingNextButton = document.getElementById("rankingNextButton");
  const rankingPrevArrow = document.getElementById("rankingPrevArrow");
  const rankingNextArrow = document.getElementById("rankingNextArrow");

  if (carouselIndex < items.length - 1) {
    carouselIndex++; // 移到下一頁
    rankingPrevButton.style.background = "#EBEBEB";
    rankingPrevArrow.style.color = "#666666";
    rankingNextButton.style.background = "#FF9664";
    rankingNextArrow.style.color = "#CCCCCC";
  } else {
    carouselIndex--;
    rankingPrevButton.style.background = "#FF9664";
    rankingPrevArrow.style.color = "#CCCCCC";
    rankingNextButton.style.background = "#EBEBEB";
    rankingNextArrow.style.color = "#666666";
  }

  const percentage = -carouselIndex * 100; // 計算 translateX 百分比
  slider.style.transform = `translateX(${percentage}%)`; // 動態更新 transform
}

// 處理手機手勢滑動
let touchStartX = 0;
let touchEndX = 0;

function handleTouchStart(e) {
  touchStartX = e.changedTouches[0].screenX;
}

function handleTouchEnd(e) {
  touchEndX = e.changedTouches[0].screenX;
  if (Math.abs(touchStartX - touchEndX) > 50) {
    updateRankingSliderPosition();
  }
}

function initializeRankingCarousel() {
  const elements = [
    'rankingPrevArrow',
    'rankingNextArrow',
    'rankingPrevButton',
    'rankingNextButton'
  ];

  elements.forEach(id => {
    const element = document.getElementById(id);
    if (element) {
      element.addEventListener('click', () => {
        updateRankingSliderPosition()
      });
    }
  });
}

function getCurrentDate() {
  const now = new Date()
  const latestDate = `${now.getFullYear()}/${String(now.getMonth() + 1).padStart(2, '0')}/${String(now.getDate()).padStart(2, '0')}`
  const updateDate = document.getElementById("group-latest-date")
  updateDate.textContent =  `${latestDate} 更新`
}

function loadScript() {
  let url = `https://${window.location.host}/next/api/funds/detail/${mfxId}/performance`;
  fetch(url)
    .then((response) => {
      // 檢查回應是否成功
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json(); // 將回應轉換為 JSON 格式
    })
    .then((data) => {
      //建立基本資料區域
      const rankingInfo = document.createElement("div");

      //渲染基本資料
      rankingInfo.innerHTML = `
        <div>
            <div style="color: #333333; font-weight: 500; font-size: 18px; line-height: 1.75rem; margin-bottom: 0.75rem;">
                同類組績效排名
                <span id="group-latest-date" style="font-size: 14px; color: #999999"></span>
            </div>

            <div class="mobile-table-container">
              <div style="overflow: hidden; width: 100%; margin: auto;"> 
                <div class="ranking-info-container" id="ranking-slider" style="transform: translateX(0%)">
                  <div style="border-radius: 4px; overflow: hidden; border: 1px solid #E0E0E0; width: 100%; flex-shrink: 0;">
                      <table style="border-collapse: collapse; table-layout: fixed; width: 100%;">
                          <thead id="ranking-thead-1" style="background-color: #E0E0E0; white-space: nowrap;"></thead>
                          <tbody id="ranking-tbody-1"></tbody>
                      </table>
                  </div>
                  <div style="border-radius: 4px; overflow: hidden; border: 1px solid #E0E0E0; width: 100%; flex-shrink: 0;">
                      <table style="border-collapse: collapse; table-layout: fixed; width: 100%;">
                          <thead id="ranking-thead-2" style="background-color: #E0E0E0; white-space: nowrap;"></thead>
                          <tbody id="ranking-tbody-2"></tbody>
                      </table>
                  </div>
                </div>
              </div>

              <div class="carousel-button-container">
                <div id="rankingPrevArrow" style="width: 12px; height:12px; color: #CCCCCC; margin-right: auto; display: flex; justify-content: center; align-items: center; cursor: pointer;">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M34.5 239L228.9 44.7c9.4-9.4 24.6-9.4 33.9 0l22.7 22.7c9.4 9.4 9.4 24.5 0 33.9L131.5 256l154 154.8c9.3 9.4 9.3 24.5 0 33.9l-22.7 22.7c-9.4 9.4-24.6 9.4-33.9 0L34.5 273c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>
                </div>
                <button id="rankingPrevButton" style="width: 8px; height: 8px; background: #FF9664; border-radius: 50%; flex-shrink: 0; border: none; cursor: pointer; padding: 0; margin-right: 8px;"></button>
                <button id="rankingNextButton" style="width: 8px; height: 8px; background: #EBEBEB; border-radius: 50%; flex-shrink: 0; border: none; cursor: pointer; padding: 0;"></button>
                <div id="rankingNextArrow" style="width: 12px; height:12px; color: #666666; margin-left: auto; display: flex; justify-content: center; align-items: center; cursor: pointer;">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M285.5 273L91.1 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.7-22.7c-9.4-9.4-9.4-24.5 0-33.9L188.5 256 34.5 101.3c-9.3-9.4-9.3-24.5 0-33.9l22.7-22.7c9.4-9.4 24.6-9.4 33.9 0L285.5 239c9.4 9.4 9.4 24.6 0 33.9z"/></svg>
                </div>
              </div>
            </div>
            <div class="laptop-table-container">
              <div style="border-radius: 4px; overflow: hidden; border: 1px solid #E0E0E0; width: 100%; flex-shrink: 0;">
                  <table style="border-collapse: collapse; table-layout: fixed; width: 100%;">
                      <thead id="laptop-ranking-thead" style="background-color: #E0E0E0; white-space: nowrap;"></thead>
                      <tbody id="laptop-ranking-tbody"></tbody>
                  </table>
              </div>
            </div>
            <div style="font-size: 14px; margin-top: 16px; background: #f5f5f5; padding: 16px; border-radius: 4px;">資料來源：好好證券彙整，詳見重要聲明。</div>
        </div>
    `;

      const targetElement = document.getElementById("fundGroupRankingScript");
      targetElement.innerHTML = '';
      targetElement.appendChild(rankingInfo);
      
      renderRankingHead();
      renderRankingRow(data);
      initializeRankingCarousel();
      getCurrentDate();
    })
    .catch((error) => {
      // 捕獲並處理錯誤
      console.error("發生錯誤:", error);
    });
}

loadScript();

window.addEventListener("touchstart", handleTouchStart);
window.addEventListener("touchend", handleTouchEnd);

window.addEventListener("beforeunload", () => {
  window.removeEventListener("touchstart", handleTouchStart);
  window.removeEventListener("touchend", handleTouchEnd);
});